import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-core";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
import _utils from "../utils/utils";
var exports = {};
var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverAssetApi = void 0;
const sdk_geometry_api_sdk_core_1 = _sdk;
const utils_1 = _utils;
const apiAssetExportUri = /.+\/session\/.+\/export\/.+/;
const apiAssetOutputUri = /.+\/session\/.+\/output\/.+/;
const apiAssetTextureUri = /.+\/session\/.+\/texture\/.+/;
const cdnAssetUri = /.+\/cdn-asset-(exports|outputs|textures)\/.+/;
const cdnAssetExportUri = /.+\/cdn-asset-exports\/.+/;
const cdnAssetOutputUri = /.+\/cdn-asset-outputs\/.+/;
const cdnAssetTextureUri = /.+\/cdn-asset-textures\/.+/;
class ShapeDiverAssetApi extends sdk_geometry_api_sdk_core_1.BaseResourceApi {
  constructor(api) {
    super(api);
  }
  getExport(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const [header, data] = yield this.api.get(`${this.buildSessionUri(sessionId)}/export/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA
        });
        const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
        return [data, contentType];
      }));
    });
  }
  getOutput(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const [header, data] = yield this.api.get(`${this.buildSessionUri(sessionId)}/output/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA
        });
        const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
        return [data, contentType];
      }));
    });
  }
  getSdtfJsonContent(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        return (yield this.api.get(`${this.buildSessionUri(sessionId)}/output/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.JSON,
          accept: "model/vnd.sdtf+json"
        }))[1];
      }));
    });
  }
  getTexture(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const [header, data] = yield this.api.get(`${this.buildSessionUri(sessionId)}/texture/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA
        });
        const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
        return [data, contentType];
      }));
    });
  }
  getGltf(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        return (yield this.api.get(`${this.buildSessionUri(sessionId)}/gltf/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA
        }))[1];
      }));
    });
  }
  getUsdz(sessionId, assetData) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        return (yield this.api.get(`${this.buildSessionUri(sessionId)}/usdz/${assetData}`, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA
        }))[1];
      }));
    });
  }
  downloadImage(sessionId, url) {
    return __awaiter(this, void 0, void 0, function* () {
      let targetUrl;
      if (apiAssetTextureUri.test(url) || cdnAssetTextureUri.test(url)) {
        targetUrl = url;
      } else {
        targetUrl = `${this.buildSessionUri(sessionId)}/image?url=${(0, utils_1.encodeBase64)(url)}`;
      }
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const [header, data] = yield this.api.get(targetUrl, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA,
          disableAuthorization: cdnAssetUri.test(url)
        });
        const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
        return [data, contentType];
      }));
    });
  }
  getAsset(url) {
    return __awaiter(this, void 0, void 0, function* () {
      let type;
      if (apiAssetExportUri.test(url) || cdnAssetExportUri.test(url)) type = "export";else if (apiAssetOutputUri.test(url) || cdnAssetOutputUri.test(url)) type = "output";else if (apiAssetTextureUri.test(url) || cdnAssetTextureUri.test(url)) type = "texture";else throw new sdk_geometry_api_sdk_core_1.ShapeDiverError("Cannot fetch asset: Invalid URL (only ShapeDiver asset URLs are allowed).");
      return yield (0, utils_1.sendRequest)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const [header, data] = yield this.api.get(url, {
          responseType: sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType.DATA,
          disableAuthorization: cdnAssetUri.test(url)
        });
        const contentType = (_a = header["Content-Type"]) !== null && _a !== void 0 ? _a : header["content-type"];
        return [data, contentType, type];
      }));
    });
  }
}
exports.ShapeDiverAssetApi = ShapeDiverAssetApi;
//# sourceMappingURL=ShapeDiverAssetApi.js.map
export default exports;